import type { JSX, ReactNode, HTMLAttributes } from 'react';
import { styled } from 'styled-components';
import { TableSectionContext } from './TableSectionContext';

const StyledTableFoot = styled.tfoot`
  width: 100%;
`;

export type TableFootProps = HTMLAttributes<HTMLTableSectionElement> & {
  children?: ReactNode;
};

export const TableFoot = ({ children, ...props }: TableFootProps): JSX.Element => {
  return (
    <TableSectionContext.Provider value="footer">
      <StyledTableFoot {...props}>{children}</StyledTableFoot>
    </TableSectionContext.Provider>
  );
};
